import React from 'react';
import './Notice.css';

const NoticeCompanyChange = () => {
  return (
    <div className="notice-page">
      <div className="page-header">
        <div className="container">
          <h1>お知らせ</h1>
        </div>
      </div>

      <section className="section">
        <div className="container">
          <div className="notice-content">
            <h2>【重要】ゴルマチ運営会社変更（事業譲渡）のお知らせ</h2>
            <p>ゴルマチをご利用いただき、誠にありがとうございます。</p>
            <p>このたび、株式会社ゴルマチ（以下「旧運営会社」）が運営する「ゴルマチ（ｇｏｌｍａｃｈｉ）　ゴルフ専用マッチングアプリ」（以下「ゴルマチアプリ」）に関する事業が、2026年1月15日（予定）をもって、株式会社Gol-Pal（以下「新運営会社」）へ譲渡され（以下「本事業譲渡」）、これに伴い、ゴルマチアプリの運営会社が、旧運営会社から新運営会社に変更となる予定となりましたので、お知らせいたします。</p>

            <h3>■ 運営会社変更の概要</h3>
            <p>変更前の運営会社：株式会社ゴルマチ</p>
            <p>変更後の運営会社：株式会社Gol-Pal</p>
            <p>事業譲渡予定日：2026年1月15日（予定）</p>

            <h3>■ 事業譲渡後のゴルマチアプリのご利用について</h3>
            <p>本事業譲渡後も、</p>
            <ul>
              <li>現在ご利用中のアカウント</li>
              <li>購入済みのポイント・利用権・履歴等</li>
            </ul>
            <p>は、これまでどおり変更なくご利用いただけます。</p>
            <p>サービス内容や料金体系については、現時点で変更予定はございません。</p>

            <h3>■ 個人情報の取扱いについて</h3>
            <p>本事業譲渡に伴い、旧運営会社が取得したユーザーの皆様の個人情報（メールアドレス、LINEアカウント、Apple ID等）は、新運営会社へ承継されます。</p>
            <p>なお、</p>
            <ul>
              <li>個人情報の利用目的</li>
              <li>管理方法・安全管理措置</li>
            </ul>
            <p>については、事業譲渡によって変更されることはありません。</p>

            <h3>■ 運営会社変更についての問い合わせ窓口</h3>
            <p>ゴルマチアプリの運営会社変更についてご不明点やご異議がある場合は、下記お問い合わせ窓口までご連絡ください。</p>

            <p>【お問い合わせ窓口】</p>
            <p>メールアドレス：support@golmachi.net</p>
            <p>受付期間：2026年1月8日 ～ 2026年1月15日</p>

            <h3>■ 運営会社変更に伴う規約の変更について</h3>
            <p>運営会社変更後は、利用規約その他ゴルマチアプリに関する規約（以下「利用規約等」）は、新運営会社の定めるものに変更されます。ユーザーの皆様には、改めて新運営会社の利用規約等への同意手続をお願いする予定です。</p>
            <p>詳細は、事業譲渡完了後にアプリ内またはメール等にてご案内いたします。</p>
            <p>今後とも、ゴルマチアプリを安心してご利用いただけるよう、サービスの品質向上に努めてまいります。何卒ご理解のほど、よろしくお願い申し上げます。</p>

            <p>株式会社ゴルマチ</p>
            <p>（旧運営会社）</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default NoticeCompanyChange;
